export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10334.d4c74ff8.jpg";